var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './App.scss';
import LoadingApp from './LoadingApp/LoadingApp';
import HomaPage from './HomePage/HomePage';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAppDispatch, useAppSelector } from '../hooks/hook';
import { setUser, setUserData } from '../store/slices/appSlice';
import { useTheme } from '../hooks/useTheme';
import { Suspense, lazy, useEffect, useLayoutEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
console.log("%cEasyMessenger by sheva2103, GitHub: https://github.com/sheva2103/easy-messenger, email: 2103sheva@gmail.com", "color: #8774e1; font-size: 16px;");
import { PWAInstallPrompt } from './PWA/PWAInstall';
const StartPageLazy = lazy(() => import('./StartPage/StartPage'));
export const App = () => {
    const { theme, setTheme } = useTheme();
    const [load, setLoad] = useState(true);
    const currentUser = useAppSelector(state => state.app.currentUser);
    const dispatch = useAppDispatch();
    useLayoutEffect(() => {
        const auth = getAuth();
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => __awaiter(void 0, void 0, void 0, function* () {
            if (user) {
                let unsubscribeSnapshot;
                unsubscribeSnapshot = onSnapshot(doc(db, "users", user.uid), (docSnap) => {
                    if (docSnap.exists()) {
                        const currentInfo = docSnap.data();
                        const userData = {
                            email: currentInfo.email,
                            photoURL: currentInfo.photoURL,
                            displayName: currentInfo.displayName,
                            uid: currentInfo.uid
                        };
                        dispatch(setUser(userData));
                        setLoad(false);
                        if (unsubscribeSnapshot) {
                            unsubscribeSnapshot();
                        }
                    }
                }, (error) => {
                    console.error("Snapshot error:", error);
                    setLoad(false);
                });
            }
            else {
                dispatch(setUser(null));
                setLoad(false);
            }
        }));
        return () => unsubscribeAuth();
    }, [dispatch]);
    useEffect(() => {
        if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid) {
            const unsub = onSnapshot(doc(db, "users", currentUser.uid), (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    dispatch(setUserData(data));
                }
                else {
                    console.log("Документ пользователя создается...");
                }
            });
            return () => unsub();
        }
    }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid]);
    return (_jsxs("div", { className: 'appContainer', children: [currentUser ? _jsx(HomaPage, {}) : load ?
                _jsx(LoadingApp, {})
                :
                    _jsx(Suspense, { fallback: _jsx("div", { children: "loading..." }), children: _jsx(StartPageLazy, {}) }), _jsx(PWAInstallPrompt, {})] }));
};
